export type UserRoleName =
    'architect' |
    'commercial client' |
    'domestic client' |
    'builder' |
    'building inspector' |
    'area manager' |
    'plan check engineer' |
    'building inspector company' |
    'multi-displinary'
    ;

export const getLoginUserRoleName = async (): Promise<UserRoleName | ''> => {
    try {
        const userTypeName = await Promise.resolve(localStorage.getItem('user_type_name'));
        const roleName = userTypeName ? userTypeName.toLowerCase() : '';

        const validRoles: UserRoleName[] =
            [
                'architect',
                'commercial client',
                'domestic client',
                'builder',
                'building inspector',
                'area manager',
                'plan check engineer',
                'building inspector company',
                'multi-displinary',
            ];
        return validRoles.includes(roleName as UserRoleName) ? (roleName as UserRoleName) : '';
    } catch (error) {
        return '';
    }
};

export const checkIsBuildingInspector = async (): Promise<boolean> => {
    const loginUserRoleName = await getLoginUserRoleName();

    if (!loginUserRoleName) return false;

    const inspectorRoles: UserRoleName[] = [
        'building inspector',
        'area manager',
        'building inspector company',
        'plan check engineer',
    ];

    return inspectorRoles.includes(loginUserRoleName);
};

export const checkIsArchitect = async (): Promise<boolean> => {
    const loginUserRoleName = await getLoginUserRoleName();

    if (!loginUserRoleName) return false;

    const architectRoles: UserRoleName[] = [
        'architect',
        'multi-displinary',
    ];

    return architectRoles.includes(loginUserRoleName);
};